function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { wrapDisplayName } from './utils';
/**
 * A function that returns a React HOC that adds a default className to the wrapped React component.
 *
 * This className will be extended by any additional classNames given to the component.
 * 
 * @name withClassName
 * @type Function
 * @param {String} defaultClass - The default class to add to the component
 *
 * @example
 *
 * const Block = withClassName('section-block')('section')
 * const Header = withClassName('section-header')('div')
 *
 * function Content () {
 *   return (
 *     <Block>
 *       <Header className="highlighted">
 *         This is some header text!
 *       </Header>
 *     </Block>
 *   )
 * }
 * 
 * // This is equivalent to:
 * // function Content () {
 * //   return (
 * //     <section className="section-block">
 * //       <div className="section-header highlighted">
 * //         This is some header text!
 * //       </div>
 * //     </section>
 * //   )
 * // }
 *
 */

function withClassName(defaultClass) {
  return function (Wrapped) {
    function Wrapper(_ref) {
      var className = _ref.className,
          rest = _objectWithoutProperties(_ref, ["className"]);

      return React.createElement(Wrapped, _extends({
        className: classnames(defaultClass, className)
      }, rest));
    }

    Wrapper.displayName = wrapDisplayName(Wrapped, 'withClassName');
    Wrapper.propTypes = {
      className: PropTypes.string
    };
    return Wrapper;
  };
}

export default withClassName;